import { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { FormikField } from '~/components/common/FormikField';
import { CesiumAssetUtmHemisphere } from '~/apollo/generated/v4/graphql';

export type UtmFormValues = {
  northing: number;
  easting: number;
  zone: number;
  hemisphere: string;
};

type UtmPlacementFieldsProps = {
  utmPlacement: UtmFormValues;
};

export default function VomUtmFields({
  utmPlacement,
}: UtmPlacementFieldsProps) {
  const { setFieldValue } = useFormikContext<UtmFormValues>();

  useEffect(() => {
    setFieldValue('northing', utmPlacement.northing);
    setFieldValue('easting', utmPlacement.easting);
    setFieldValue('zone', utmPlacement.zone);
    setFieldValue('hemisphere', utmPlacement.hemisphere);
  }, [utmPlacement, setFieldValue]);

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-4">
        <Field
          name="northing"
          label="Northing"
          component={FormikField}
          type="number"
          placeholder="Northing"
        />
        <Field
          name="easting"
          label="Easting"
          component={FormikField}
          type="number"
          placeholder="Easting"
        />
        <Field
          name="zone"
          label="Zone"
          component={FormikField}
          type="number"
          placeholder="Zone"
        />
        <div>
          <Field
            name="hemisphere"
            label="Hemisphere"
            component={FormikField}
            type="radio"
            inline
            className="mt-2"
            options={[
              {
                text: 'North',
                value: CesiumAssetUtmHemisphere.North,
                disabled: false,
              },
              {
                text: 'South',
                value: CesiumAssetUtmHemisphere.South,
                disabled: false,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
